import { TFunction } from 'i18next'

export const getSelectionRuleTranslation = (
    minQuantity: number,
    maxQuantity: number | null,
    t: TFunction<'app'>
) => {
    if (minQuantity === maxQuantity) {
        return t('pos.optionGroup.selectionRule.exact', { count: minQuantity })
    }

    if (minQuantity > 0 && maxQuantity === null) {
        return t('pos.optionGroup.selectionRule.atLeast', { count: minQuantity })
    }

    if (minQuantity === 0 && maxQuantity !== null) {
        return t('pos.optionGroup.selectionRule.upTo', { count: maxQuantity })
    }

    if (minQuantity > 0 && maxQuantity !== null) {
        return t('pos.optionGroup.selectionRule.atLeastAndUpTo', {
            minQuantity,
            count: maxQuantity,
        })
    }
}
